import React, { useState } from 'react';

const FIELDS = {
    author: 'author',
    file: 'file',
};

function SocialFlyerImageModal({ setModalOpen, setSelectedImage }) {
    const [imageAuthor, setImageAuthor] = useState('');
    const [imageFile, setImageFile] = useState('');
    const [imageFilename, setImageFilename] = useState('');

    function handleSubmit(e) {
        e.preventDefault();
        setSelectedImage(imageFile);
        setModalOpen(null);
    }

    function onCancelClick() {
        setModalOpen(null);
    }

    function handleChange(e) {
        const { value, name, files } = e.target;
        switch(name) {
            case FIELDS.author:
                setImageAuthor(value);
                break;
            case FIELDS.file:
                setImageFilename(value);
                setImageFile(files[0]);
                break;
        }
    }

    return (
        <div>
            <div className="full-page-overlay" onClick={onCancelClick} />
            <div className="modal-container">
                <div className="modal-container__modal edit-modal">
                    <form onSubmit={handleSubmit}>
                        <div className="mdl-textfield" style={{ width: '100%' }}>
                            <label className="mdl-typography--body-1" htmlFor="author">
                                Author*
                            </label>
                            <input
                                required
                                placeholder="Image owner or photographer"
                                id="author"
                                className="mdl-textfield__input edit-modal__input"
                                type="text"
                                name={FIELDS.author}
                                value={imageAuthor}
                                onChange={handleChange} />
                        </div>
                        <div className="mdl-textfield" style={{ width: '100%' }}>
                            <label className="mdl-typography--body-1" htmlFor="image">
                                Image*
                            </label>
                            <input
                                required
                                id="image"
                                className="mdl-textfield__input edit-modal__input"
                                type="file"
                                accept="image/jpeg,image/png"
                                name={FIELDS.file}
                                value={imageFilename}
                                onChange={handleChange} />
                        </div>
                        <div style={{ marginBottom: "12px" }}>
                        </div>
                        <div style={{ marginBottom: "12px" }}>
                            <strong>Specs:</strong> for best results use an image in PNG or JPEG format with the dimensions 1080 x 1350 pixels (4:5 ratio).
                            <br /><br />
                            <strong>Usage:</strong> only upload images you own or have permission to share.
                        </div>
                        <div className="edit-modal__buttons">
                            <button
                                className="mdl-button mdl-button--raised button-responsive"
                                name="cancel"
                                type="button"
                                onClick={onCancelClick}>
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="mdl-button mdl-button--raised button-blue button-responsive"
                                name="save">
                                Upload
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default SocialFlyerImageModal;
